import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LayoutHeader from '../../../../layout/LayoutHeader';
import AddedCustomCard from '../../../../components/AddSection/Custom/AddedCustomCard';
import Delete from '../../../../svg/Delete';
import { deleteCustomBrandSection } from '../../../../store/addsection/addsectionThunk';
import { setDeleteAlert } from '../../../../store/alert/alertSlice';
import EditIcon from '../../../../svg/EditSvg';

export default function ExistingSection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let token = localStorage.getItem("dizeeToken");
  const customSections = useSelector((state) => state.addsection.customSections);
  console.log(`customSections::`, customSections)

  useEffect(() => {
    // TODO: Add fetch custom sections thunk when backend is ready
  }, [dispatch]);

  return (
    <LayoutHeader>
      <div className="w-[390px] flex flex-col items-center relative z-[0]">
        <div className='px-4 my-[50px] flex w-full justify-between'>
          <p className='text-white'>Existing Sections</p>
          <div className='flex gap-[30px]'>
            <p onClick={() => navigate('/add-section/custom')}
              className='text-white cursor-pointer'>
              Go back
            </p>
          </div>
        </div>

        {customSections?.length > 0 ? (
          <div className="flex flex-col justify-center items-center w-full">
            {customSections.filter(section => section.type == 'music').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`MUSIC`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/music/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <div className="flex flex-row items-center gap-x-[15px]">
                    <button onClick={() => {
                      dispatch(setDeleteAlert({
                        type: 'custom-brand',
                        data: {
                          token, payload: {
                            ...section
                          }
                        }
                      }));
                    }} >
                      <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                    </button>
                  </div>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'video').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`VIDEO`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/video/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'event').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`EVENT`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/event/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'product').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`PRODUCT`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/product/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'form').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`FORM`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/form/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'social').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`SOCIAL`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    navigate('/add-section/custom/social/edit-content', {
                      state: section
                    })
                  }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
            {customSections.filter(section => section.type == 'text').map((section, index) => (
              <div className='p-4 py-6 flex w-full justify-between items-center'>
                <div className='flex flex-row items-center'>
                  <span className='text-white w-[90px]'>{`TEXT`}</span>
                  <span className='text-white'>{section.sectionTitle}</span>
                </div>
                <div className="flex flex-row items-center gap-x-[15px]">
                  <button onClick={() => {
                    // dispatch(deleteCustomBrandSection({ token, payload: section }))
                    dispatch(setDeleteAlert({
                      type: 'custom-brand',
                      data: {
                        token, payload: {
                          ...section
                        }
                      }
                    }));
                  }} >
                    <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                  </button>
                </div>

              </div>
            ))}
          </div>
        )
          :
          (
            <div className="text-white mt-8 px-4 w-full">
              <p>Create a new custom section to get started.</p>
            </div>
          )}
      </div>
    </LayoutHeader>
  );
}
